<script lang="ts">
	import { fade } from 'svelte/transition';
	import ModernBackground from './ModernBackground.svelte';
	import { themes } from './theme';

	interface Props {
		children?: import('svelte').Snippet;
		className?: string;
		classContent?: string;
		legacyDesign?: boolean;
		surfaceDesign?: boolean;
		glassDesign?: boolean;
		color?: string | number;
		transparent?: boolean;
		blur?: boolean;
		title?: string;
	}

	let {
		children = undefined,
		className = '',
		classContent = '',
		legacyDesign = false,
		surfaceDesign = false,
		glassDesign = true,
		color = undefined,
		transparent = false,
		blur = false,
		title = undefined
	}: Props = $props();

	let effectiveClassName = $derived(
		surfaceDesign
			? 'p-4 rounded-xl border border-border! dark:border-border-dark! bg-surface! dark:bg-surface-dark!'
			: className
	);
	let effectiveLegacyDesign = $derived(surfaceDesign ? true : legacyDesign);
</script>

{#if !glassDesign}
	{@render children?.()}
{:else}
	<div
		{title}
		class="{transparent ? '' : blur ? 'backdrop-blur-xl' : 'backdrop-blur-md'}
		{!isNaN(Number(color))
			? themes[Number(color)]
				? 'border ' + themes[Number(color)].border + ' ' + themes[Number(color)].background
				: 'border border-surface/20'
			: color
				? `bg-${color} border border-${color}`
				: 'border border-surface/30' +
					(transparent ? ' ' : ' dark:border-surface-dark/40') +
					(transparent ? ' ' : ' bg-surface/10') +
					(transparent ? ' ' : ' dark:bg-surface-dark/40')}

		{color && color === 23
			? 'text-surface-on dark:text-surface-dark-on border border-border dark:border-border-dark'
			: ''}
relative
		{effectiveLegacyDesign
			? 'dark:text-surface/70 '
			: color !== 'primary'
				? 'text-surface dark:text-surface'
				: 'text-primary-on dark:text-primary-on'}
		transition-all duration-1000
		{effectiveClassName} overflow-hidden"
	>
		{#if color && !isNaN(Number(color))}
			<div transition:fade class="absolute flex flex-1 inset-0 -z-10 overflow-hidden">
				<ModernBackground
					color={effectiveLegacyDesign ? 9 : Number(color)}
					size="h-full w-full"
				/>
			</div>
		{/if}
		<div class={classContent}>
			{@render children?.()}
		</div>
	</div>
{/if}
